import { NICHES } from "./niches";

export const NICHE_LANDING_PAGES = [
    {
        id: NICHES.HEALTHCARE.id,
        label: "Healthcare",
        icon: "bi-heart-pulse",
        header: "Create content daily for your clinic, dental practice, or pharmacy",
        description:
            "See what's trending in healthcare right now and turn it into beautiful, trustworthy posts for Facebook & Instagram — built around topics your patients care about, ready to publish every day.",
        seoTitle: "AI Marketing for Healthcare Businesses, Clinics & Medical Practices",
        path: NICHES.HEALTHCARE.path,
        keywords:
            "AI marketing healthcare, medical practice marketing, clinic social media, healthcare content marketing, patient engagement, wellness marketing, EzePulse",
    },
    {
        id: NICHES.BEAUTY_WELLNESS.id,
        label: "Beauty & Wellness",
        icon: "bi-scissors",
        header: "Create content daily for your salon, spa, or makeup studio",
        description:
            "Discover what's trending in beauty right now and turn it into beautiful posts for Facebook & Instagram — fresh angles for your salon, nail bar, or bridal makeup business, every day.",
        seoTitle: "AI Marketing for Salons, Spas & Beauty Businesses",
        path: NICHES.BEAUTY_WELLNESS.path,
        keywords:
            "AI marketing beauty, salon marketing, spa social media, makeup artist marketing, hair salon content, nail studio promotions, EzePulse",
    },
    {
        id: NICHES.FITNESS_WELLNESS.id,
        label: "Fitness & Wellness",
        icon: "bi-activity",
        header: "Create content daily for your Gym, Studio, or Nutrition Practice",
        description:
            "Find what's trending in fitness and wellness and turn it into motivating posts for Facebook & Instagram — daily content that speaks to members, trainees, and health-conscious clients.",
        seoTitle: "AI Marketing for Gyms, Fitness Studios & Nutrition Businesses",
        path: NICHES.FITNESS_WELLNESS.path,
        keywords:
            "gym marketing AI, fitness studio social media, personal trainer content, nutrition business marketing, wellness promotions, EzePulse",
    },
    {
        id: NICHES.HOSPITALITY_FOOD.id,
        label: "Restaurants & Hotels",
        icon: "bi-cup-hot",
        header: "Create content daily for your Restaurant, Café, Hotel, or Bakery",
        description:
            "See what's trending in food and hospitality and turn it into beautiful posts for Facebook & Instagram — daily promos and stories that fill tables, rooms, and order queues.",
        seoTitle: "AI Marketing for Restaurants, Hotels & Hospitality Businesses",
        path: NICHES.HOSPITALITY_FOOD.path,
        keywords:
            "restaurant marketing AI, hotel social media, hospitality campaigns, café promotions, food business marketing, local restaurant ads, EzePulse",
    },
    {
        id: NICHES.PROFESSIONAL_HOME_SERVICES.id,
        label: "Professional & Home",
        icon: "bi-briefcase",
        header: "Create content daily for your Firm, Shop, or Home Service Business",
        description:
            "Spot trending topics your local customers search for and turn them into polished, trust-building posts for Facebook & Instagram — for lawyers, accountants, contractors, cleaners, and more, every day.",
        seoTitle: "AI Marketing for Professional & Home Service Businesses",
        path: NICHES.PROFESSIONAL_HOME_SERVICES.path,
        keywords:
            "home service marketing, professional services AI marketing, local business leads, contractor social media, law firm marketing, EzePulse",
    },
    {
        id: NICHES.CREATIVE_LOCAL.id,
        label: "Creative & Local",
        icon: "bi-palette",
        header: "Create content daily for your Studio, Boutique, or Creative Business",
        description:
            "Discover what's trending in your creative niche and turn it into beautiful posts for Facebook & Instagram — showcase your work daily and stay top of mind with local clients.",
        seoTitle: "AI Marketing for Creative, Event & Local Businesses",
        path: NICHES.CREATIVE_LOCAL.path,
        keywords:
            "creative business marketing, event promotion AI, local boutique marketing, studio social media, small business campaigns, EzePulse",
    },
];

export function getNicheLandingByPath(pathname) {
    const normalized =
        pathname?.endsWith("/") && pathname.length > 1 ? pathname.slice(0, -1) : pathname;
    return NICHE_LANDING_PAGES.find((page) => page.path === normalized) ?? null;
}

export function getNicheLandingById(nicheId) {
    return NICHE_LANDING_PAGES.find((page) => page.id === nicheId) ?? null;
}
